import { Login } from '@/api/api.js'
import store from '@/store'
import { Toast } from 'vant'
function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
}
//是否微信浏览器
function isWeixinBrowser() {
    let ua = navigator.userAgent.toLowerCase();
    return /micromessenger/.test(ua) ? true : false;
}

export const getCode = () =>{
    let flag = false
    return new Promise( async (resolve, reject) => {

        //判断如果是微信浏览器则执行原获取信息，非微信浏览器则不进行微信信息获取
        if(!isWeixinBrowser()){
            console.log('是否微信端','非微信浏览器')
            store.commit('setAuth', 1)
            resolve()
            return
        }
        const searchParams = new URLSearchParams(window.location.search)
        const urlCode = searchParams.get('code')
        if(!store.state.is_auth){
            if (!urlCode) {
                var redirect_urls = encodeURIComponent(window.location.href)
                
                //let appid = 'wx006abb35e015ca5c'
                let appid = 'wx5b22575dc55978cd'
        
                var urls =
                    'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                    appid +
                    '&redirect_uri=' +
                    redirect_urls +
                    '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
                window.location.replace(urls)
            } else {
                if(flag) return 
                flag = true
                //传CODE给服务端，获取用户头像/昵称/openid/update时间等信息
                const res = await Login({ code: urlCode })
                flag = false
                if(res && res.code === 1000){
                    store.commit('setAuth', 1)
                    resolve()
                } else {
                    Toast(res.msg)
                    reject()
                }
            }
        } else {
            resolve()
        }
    })
    
     
    
}